// Frontend version - set via runtime env injection or build-time env
// Runtime injection takes priority (for Docker deployments)
// Note: Window.ENV type is declared in authConfig.ts

const getVersionEnv = (key: 'VITE_APP_VERSION' | 'VITE_BUILD_HASH', fallback: string): string => {
  // Check runtime injection first (Docker), then build-time env (dev)
  const runtimeValue = window.ENV?.[key];
  if (runtimeValue && !runtimeValue.startsWith('__')) {
    return runtimeValue;
  }
  return import.meta.env[key] || fallback;
};

// Real version comes from the VERSION file via CI build args; 'dev' = local dev
export const FRONTEND_VERSION = getVersionEnv('VITE_APP_VERSION', 'dev');
export const FRONTEND_BUILD = getVersionEnv('VITE_BUILD_HASH', 'dev');
